import { render } from "./SingleToilet.vue?vue&type=template&id=67ffc116&scoped=true"
import script from "./SingleToilet.vue?vue&type=script&lang=js"
export * from "./SingleToilet.vue?vue&type=script&lang=js"

import "./SingleToilet.vue?vue&type=style&index=0&id=67ffc116&lang=scss&scoped=true"

import exportComponent from "D:\\project\\digital-signage-cockpit-40\\防疫数据驾驶舱4.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67ffc116"]])

export default __exports__